module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAANwAAAAOCAYAAABErHKlAAAAAXNSR0IArs4c6QAAAVtJREFUaEPt2bFKw1AYBeDzJ6Gl0ClbdOqiNIUsPktfQgTrG/gAgu1z+DISMKWTTjqIToq0JPklQ6SmN2lIsuVkzb1/yMc93OEIaj6zG3WHCSY1l3MZBShgEJA6Kv5cB4NT+FYKu856rqEABQ4FYmBbK3DBtZ47ijERKUCBZgJxAsUIm6OBmy7UG6U4afYZ7qIABTKBHwuv66W8VQbOv9SxIzhzbBwNJlkpQAGzQCz4Cleyyd6WB2muduBh6gBDQlKAAs0E0hjJ7h1R9CC7ysAFVzpxLLjNPsNdFKBAJrC18fx0L5+5hvGGYwXAw0KB9gKphY/HpbzsTzoIHCuA9tCcQIGsAghdRLiVtDJwrAB4WCjQTiCvAMI7+S5O+nfDXSzUU1YA7bS5u/cCeQVggvgLHCuA3p8TAnQgsF8BlAeOFUAH1BzRd4FiBVAaOFYAfT8q/P8uBIoVgGnmL6edYVRUOTqoAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/parallelogram.png
// module id = llYU
// module chunks = 0